
export { localStorageUtils } from "/codebuild/output/src187247037/src/packages/utils/src/storage/index.ts"